
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";
import BrandSwitchDialog from "../dialogs/brand-switch-dialog.vue";
import ItemAddedCard from "./item-added-card.vue";
import AddToCartDialog from "../dialogs/add-to-cart-dialog.vue";
import MenuOrderMenuList from "./menu-order-menu-list.vue";
import MenuBookHeader from "../menu-book/menu-book-header.vue";
import AddedItemCustomisationDialog from "../dialogs/added-item-customisation-dialog.vue";
export default {
  components: {
    MenuBookHeader,
    BrandSwitchDialog,
    ItemAddedCard,
    AddToCartDialog,
    MenuOrderMenuList,
    AddedItemCustomisationDialog
  },
  data() {
    return {
      showAddToCartDialog: false,
      showAddedItemCustomisationDialog: false,
      selectedItemToAdd: {},
      selectedItemToCustomise: {}
    };
  },
  created() {
    this.fetch();
    this.$nuxt.$on("open-add-to-cart-dialog", this.handleOpenAddToCartDialog);
    this.$nuxt.$on(
      "open-added-item-customisation-dialog",
      this.handleOpenAddedItemCustomisationDialog
    );
  },
  beforeMount() {
    this.SET_SELECTED_GROUP_BY_MENU("category");
  },
  mounted() {
    if (this.cart.delivery_address && !this.addresses.length) {
      this.validateCartAddress();
    }
  },
  watch: {
    "restaurantDetails.location": {
      handler() {
        this.fetch();
      },
      deep: true
    }
  },
  computed: {
    ...mapState("order", ["restaurantDetails", "cart", "addresses"]),
    ...mapState("menu", ["menuLoading", "menuItems"])
  },
  methods: {
    ...mapActions("menu", ["getMenuListForOrder", "getCategories"]),
    ...mapActions("order", ["validateCartAddress"]),
    ...mapMutations("menu", ["SET_MENU_LOADING", "SET_SELECTED_GROUP_BY_MENU"]),
    async fetch() {
      if (!this.restaurantDetails.location) return;
      this.SET_MENU_LOADING(true);
      await Promise.all([
        this.getCategories({
          forceFetch: false,
          id: this.restaurantDetails.location?.id
        }),
        this.getMenuListForOrder({
          forceFetch: false,
          brandId: this.restaurantDetails.restaurant_id
        })
      ]);
      this.SET_MENU_LOADING(false);
    },
    handleOpenAddToCartDialog(item) {
      this.showAddToCartDialog = true;
      this.selectedItemToAdd = { ...item };
    },
    handleOpenAddedItemCustomisationDialog(item) {
      this.showAddedItemCustomisationDialog = true;
      this.selectedItemToCustomise = { ...item };
    }
  },
  beforeDestroy() {
    this.$nuxt.$off("open-add-to-cart-dialog");
    this.$nuxt.$off("open-added-item-customisation-dialog");
  }
};
